var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeacon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1477_276831)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18,
    r: 16,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8433 8.14925V13.6657C25.8433 13.9522 25.8433 14.2388 25.7717 14.5254C25.7717 14.6328 25.7537 14.7582 25.7358 14.8836L25.7358 14.8836C25.7179 15.009 25.7 15.1343 25.7 15.2418C25.6284 15.7433 25.4134 16.3164 25.1985 16.8179C24.912 17.5343 24.5537 18.1791 24.0523 18.8239C23.1926 19.8985 22.1179 20.7582 20.9 21.403C20.3985 21.1164 20.0403 20.6866 19.8254 20.1134C20.9 19.6119 21.8314 18.8955 22.6194 17.9642C23.6224 16.7463 24.1955 15.2418 24.1955 13.6657V9.15224L23.8373 9.00896C22.1179 8.2209 20.2552 7.7194 18.3925 7.64776C16.3866 7.7194 14.3806 8.29254 12.5896 9.15224V11.0149C12.303 11.1582 11.9527 11.3015 11.6025 11.4448L11.6024 11.4448C11.4273 11.5164 11.2522 11.5881 11.0851 11.6597V8.14925L11.5149 7.93433C13.6642 6.78806 16.0284 6.14328 18.4642 6C20.9 6.14328 23.2642 6.78806 25.4134 7.93433L25.8433 8.14925ZM30.5 16.1731V16.6746C30.4284 19.1104 29.7836 21.4746 28.709 23.6955C27.4194 25.7731 25.6284 27.4925 23.5507 28.7821L23.1209 28.9254L22.4045 28.4955L18.3209 26.1313C18.2134 26.0597 18.0881 25.9881 17.9627 25.9164C17.8373 25.8448 17.7119 25.7731 17.6045 25.7015C17.497 25.6298 17.4075 25.5582 17.3179 25.4866C17.2284 25.4149 17.1388 25.3433 17.0313 25.2716C16.6015 24.9134 16.2433 24.4836 15.8851 24.0538L15.8851 24.0537C15.3836 23.4806 15.0254 22.7642 14.7388 22.0478C14.2373 20.7582 14.0224 19.397 14.094 18.0358C14.5239 17.8209 14.9537 17.6776 15.3836 17.6776H15.7418C15.5985 18.8955 15.8134 20.0418 16.1716 21.1881C16.6731 22.6925 17.7478 23.9104 19.109 24.6985L23.0493 26.991L23.3358 26.7761C24.9119 25.7015 26.2015 24.3403 27.2761 22.7642C28.2075 20.9731 28.709 19.0388 28.8522 17.0328L27.2045 16.0298C27.3478 15.4567 27.4194 14.8836 27.491 14.3105L27.491 14.3104L30.5 16.1731ZM8.14776 17.0328L12.0881 14.7403C13.4493 13.9523 15.0254 13.6657 16.6015 13.9523C17.7478 14.1672 18.894 14.597 19.8254 15.3134C20.1119 14.8836 20.3269 14.3821 20.3269 13.809C19.1806 13.0925 17.891 12.5911 16.5299 12.3761C15.7418 12.3045 15.0254 12.3045 14.2373 12.3761C14.2062 12.3806 14.1748 12.385 14.1432 12.3895C13.665 12.4572 13.1316 12.5327 12.6612 12.7343C12.4463 12.806 12.2313 12.8776 12.0164 13.0209C11.8039 13.074 11.6308 13.1666 11.4386 13.2693C11.3716 13.3051 11.3024 13.3421 11.2284 13.3791L7.21642 15.7433L6.5 16.1731V16.603C6.57164 19.0388 7.14478 21.4746 8.29104 23.6239C9.5806 25.7015 11.3716 27.4209 13.4493 28.7105L13.8791 28.9254L16.9597 27.206C16.4582 26.9194 16.0284 26.5612 15.5985 26.1314L13.8791 27.0627C12.1597 25.9881 10.7269 24.5552 9.65224 22.8358C8.79254 21.1164 8.29104 19.2537 8.14776 17.3911V17.0328Z",
    fill: "#3880FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1477_276831",
    x: 0.5,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.760784 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1477_276831"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1477_276831",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeacon);
export default __webpack_public_path__ + "static/media/Beacon.aa85a0579b7db75845f2095ad4815aae.svg";
export { ForwardRef as ReactComponent };